module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-badge-container"
  }, [_vm._t("default"), _vm._v(" "), _c('em', {
    staticClass: "mu-badge",
    class: _vm.badgeInternalClass,
    style: (_vm.badgeStyle)
  }, [_vm._t("content", [_vm._v("\n      " + _vm._s(_vm.content) + "\n    ")])], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c9d4a11"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/badge/badge.vue
// module id = 454
// module chunks = 1